import React, { useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

type Props = {
  title: string;
  icon?: React.ReactNode;
  defaultOpen?: boolean;
  children: React.ReactNode;
  className?: string;
};

/**
 * Collapsible OrderForm column wrapper. Header shows an icon + title with a
 * chevron toggle; body renders children when open. Mirrors the prototype's
 * `Section` (single-file lines 1463-1524).
 */
const Section: React.FC<Props> = ({
  title,
  icon,
  defaultOpen = true,
  children,
  className,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`px-4 py-1.5 min-w-0 ${className ?? ''}`}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className={
          'flex w-full items-center justify-between gap-2 py-1 select-none ' +
          (open
            ? 'border-b border-dashed border-slate-200 dark:border-gray-700 mb-1.5'
            : '')
        }
      >
        <span className="inline-flex items-center gap-1.5 text-[0.65625rem] font-semibold uppercase tracking-wider text-slate-400 dark:text-gray-500">
          {icon && (
            <span className="text-blue-600 dark:text-blue-400 inline-flex">
              {icon}
            </span>
          )}
          {title}
        </span>
        <ChevronDownIcon
          className={`h-3 w-3 text-slate-400 dark:text-gray-500 transition-transform duration-150 ${open ? '' : '-rotate-90'}`}
          strokeWidth={2.5}
        />
      </button>
      {open && <div>{children}</div>}
    </div>
  );
};

export default Section;
